export default __webpack_public_path__ + "static/media/category-banner-Events.ac6d3b69.jpg";